/*
 * @vinejs/vine
 *
 * (c) VineJS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import { messages } from '../../defaults.js'
import { helpers } from '../../vine/helpers.js'
import { createRule } from '../../vine/create_rule.js'

/**
 * Verifies two equals are equal considering the HTML forms
 * serialization behavior.
 */
export const equalsRule = createRule<{ expectedValue: any }>((value, options, field) => {
  let input = value

  /**
   * Normalizing the field value as per the expected
   * value.
   */
  if (typeof options.expectedValue === 'boolean') {
    input = helpers.asBoolean(value)
  } else if (typeof options.expectedValue === 'number') {
    input = helpers.asNumber(value)
  }

  /**
   * Performing validation and reporting error
   */
  if (input !== options.expectedValue) {
    field.report(messages.literal, 'literal', field, options)
    return
  }

  /**
   * Mutating input with normalized value
   */
  field.mutate(input, field)
})
